import { Outlet, useNavigation } from 'react-router-dom';
import Spinner from '../common/Spinner';
import ModalProvider from '../common/ModalProvider';

function RootLayout() {
  const navigation = useNavigation();
  const isLoading = navigation.state === 'loading';

  return (
    <ModalProvider>
      <Outlet />
      {isLoading && (
        <div className="spinner-overlay">
          <Spinner size="large" />
        </div>
      )}
    </ModalProvider>
  );
}

export default RootLayout;
